<template><div /></template>

<script>
  export default {
    name: 'PropagacaoDaUniTrAtDaCtmt'
  };
</script>
